import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {VoilaUserService} from '@services/voila-user.service';
import {UserPrivilege} from '@services/resource/user-privilege';

@Directive({
  selector: '[minPrivilege]',
  standalone: true,
})
export class MinPrivilegeDirective {
  constructor(
    private readonly userService: VoilaUserService,
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<any>,
  ) {}

  createOrBreakComponent(create: boolean) {
    if (create) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  @Input() set minPrivilege(privilegeLevel: string) {
    let create = false;
    switch (privilegeLevel) {
      case 'FULL': {
        if (this.userService.currentUser().userPrivilege == UserPrivilege.FULL) {
          create = true;
        }
        break;
      }
      case 'READONLY': {
        if (this.userService.currentUser().userPrivilege == UserPrivilege.FULL) {
          create = true;
        }
        if (this.userService.currentUser().userPrivilege == UserPrivilege.READONLY) {
          create = true;
        }
        break;
      }
      default: {
        create = true;
        break;
      }
    }
    this.createOrBreakComponent(create);
  }
}
